module.exports = __webpack_public_path__ + "img/maisi.3493d3fe.svg";